<!--
 * @Description:
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-02-27 13:25:48
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<!--
Author: TangChen
Date: 2018-11-26
Desc: 用户持有银行卡信息操作组件，增卡 由index.js 配置引入
-->
<template>
    <div>
        <comp-title-dc back-url-name="info">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/info' }">个人中心</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/info' }">信息中心</el-breadcrumb-item>
                <el-breadcrumb-item>修改银行卡</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div :class="'bizcomp-add-bank bizcomp ' + className">
            <bank-operation cate="modify" />
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import bankOperation from "@/components/form/bankOperationDc";
export default {
    name: "AddBank",
    components: {
        bankOperation
    },
    mixins: [mixin],
    data() {
        return {};
    }
};
</script>
